<template>
    <div class="container">
        <router-view  />
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/layouts/BlankLayout.vue